import cx from 'classnames'
import {AppearanceProvider} from 'components/common/CartItemBuilder/providers/AppearanceProvider'
import {InputProvider} from 'components/common/CartItemBuilder/providers/InputProvider'
import {Button} from 'components/system/Button'
import * as ga4Events from 'ga4Events'
import {usePatchBookingMutation} from 'hooks/ventrata/usePatchBookingMutation'
import {OrderProvider} from 'providers/OrderProvider'
import {useCallback} from 'react'
import {convertUnitCounterMapToRequestUnitItems} from 'utils/convertUnitCounterMapToRequestUnitItems'
import {ApplyButton} from '../../ApplyButton'

type Props = {
  onError: (error: unknown) => void
}

export const SaveButton = ({onError}: Props) => {
  const builderManager = AppearanceProvider.useManager()
  const unitCounters = InputProvider.useUnitCounters('optional')
  const availabilityId = InputProvider.useAvailabilityId('optional')
  const optionId = InputProvider.useOptionId('optional')
  const productId = InputProvider.useProductId()
  const cartItemId = InputProvider.useId()
  const optionalOrder = OrderProvider.useOrder('optional')
  const setOrder = OrderProvider.useOrderSetter()
  const patchBookingMutation = usePatchBookingMutation()
  const crossSellingFlag = builderManager.action === 'creatingMore'

  const patchBooking = patchBookingMutation.mutate

  const saveCartItem = useCallback(() => {
    patchBooking(
      {
        productId,
        optionalOrderId: optionalOrder?.id,
        bookingUuid: cartItemId,
        availabilityId,
        optionId,
        unitItems: convertUnitCounterMapToRequestUnitItems(unitCounters),
      },
      {
        onSuccess(updatedOrder) {
          if (!optionalOrder) {
            console.log('Order is null. This should never happen')
          } else {
            ga4Events.changeCartItem({order: optionalOrder, updatedOrder, bookingUuid: cartItemId, crossSellingFlag})
          }

          document.dispatchEvent(
            new CustomEvent('CheckoutCartChanged', {detail: {bookings: updatedOrder?.bookings.length ?? 0}})
          )

          setOrder(updatedOrder)
          builderManager.onClose()
        },
        onError,
      }
    )
  }, [
    builderManager,
    cartItemId,
    patchBooking,
    availabilityId,
    optionId,
    unitCounters,
    setOrder,
    productId,
    optionalOrder,
    crossSellingFlag,
    onError,
  ])

  return (
    <ApplyButton
      onClick={saveCartItem}
      onError={onError}
      render={({onClick, disabled}) => {
        return (
          <Button.Primary.Orange
            onClick={onClick}
            disabled={disabled}
            autoExpanded
            className={cx(disabled ? '!bg-inactive-gray' : '!bg-theme')}
          >
            Save and Keep Browsing
          </Button.Primary.Orange>
        )
      }}
    />
  )
}
